<template>
  <div id="admin-about">
    <form @submit.stop.prevent="onSubmit">
      <div class="row">
        <div class="col-12">
          <h4 class="text-blue"><b><u>About Management</u></b></h4>
        </div>
        <div class="col-6">
          <b-form-group label="Address:">
            <b-form-textarea :disabled="!flagEdit ? true : false" v-model="form.address" rows="3" id="address"
              name="address" v-validate="{ required: true }" :state="validateState('address')"></b-form-textarea>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Telephone:">
            <b-form-input :disabled="!flagEdit ? true : false" v-model="form.telephone" id="telephone" name="telephone"
              v-validate="{ required: true }" :state="validateState('telephone')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Email:">
            <b-form-input type="email" :disabled="!flagEdit ? true : false" v-model="form.email" id="email" name="email"
              v-validate="{ required: true, email: true }" :state="validateState('email')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="line ID:">
            <b-form-input :disabled="!flagEdit ? true : false" v-model="form.lineId" id="lineId" name="lineId"
              v-validate="{ required: true }" :state="validateState('lineId')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="line Name:">
            <b-form-input :disabled="!flagEdit ? true : false" v-model="form.lineName" id="lineName" name="lineName"
              v-validate="{ required: true }" :state="validateState('lineName')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="facebook Link:">
            <b-form-input :disabled="!flagEdit ? true : false" v-model="form.facebookLink" id="facebookLink"
              name="facebookLink" v-validate="{ required: true }" :state="validateState('facebookLink')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="facebook Name:">
            <b-form-input :disabled="!flagEdit ? true : false" v-model="form.facebookName" id="facebookName"
              name="facebookName" v-validate="{ required: true }" :state="validateState('facebookName')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group label="Map:">
            <b-form-input :disabled="!flagEdit ? true : false" v-model="form.mapCode" id="mapCode" name="mapCode"
              v-validate="{ required: true }" :state="validateState('mapCode')"></b-form-input>
          </b-form-group>
        </div>
        <div class="col-12 text-right">
          <div class="border-top pt-3">
            <b-button variant="warning" @click="flagEdit = true" class="mr-2"><i class="fas fa-edit"></i> Edit
            </b-button>
            <b-button type="submit" variant="success" :disabled="!flagEdit ? true : false"><i class="fas fa-check"></i>
              Save</b-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        flagEdit: false,
        form: {
          address: '',
          telephone: '',
          email: '',
          lineId: '',
          lineName: '',
          facebookLink: '',
          facebookName: '',
          mapCode: ''
        }
      }
    },
    mounted() {
      this.getAbout()
    },
    methods: {
      getAbout() {
        let loading = this.$loading.show()
        this.$http.get(this.$app.baseURL + this.$path.about).then(
          res => {
            loading.hide()
            this.form = res.data.data[0]
          }, () => {
            loading.hide()
          }
        )
      },
      validateState(ref) {
        if (this.$veeFields[ref] && (this.$veeFields[ref].dirty || this.$veeFields[ref].validated)) {
          return !this.$veeErrors.has(ref);
        }
        return null;
      },
      onSubmit() {
        this.$validator.validateAll().then(result => {
          if (!result) {
            return;
          }
          let loading = this.$loading.show()
          const formData = new FormData
          formData.append('address', this.form.address)
          formData.append('telephone', this.form.telephone)
          formData.append('email', this.form.email)
          formData.append('line_id', this.form.lineId)
          formData.append('line_name', this.form.lineName)
          formData.append('facebook_link', this.form.facebookLink)
          formData.append('facebook_name', this.form.facebookName)
          formData.append('map_code', this.form.mapCode)
          this.$http.post(this.$app.baseURL + this.$path.aboutUpdate, formData).then(
            res => {
              loading.hide()
              if (res.data.status == 200) {
                this.toastSaveSuccess()
              } else {
                this.toastSaveWarning()
              }
            }, () => {
              loading.hide()
              this.toastSaveWarning()

            }
          )
        });
      }
    }
  }
</script>

<style scoped>
</style>